import { FC, useMemo, useState } from "react";
import { Link } from "react-router";
import { machineDetailPath } from "../../../../../constants/machineRoutes";
import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from "reactstrap";
import { useAllDevicesForUser } from "../../../../../common/hooks/api/device";
import { ScreenOverlay, Spinner } from "../../../../../components/Common";
import { toastError } from "../../../../../helpers/toast-helper";
import { getResponseItemData } from "../../../../../helpers/response-helper";
import MapWithMarkers from "../map";
import { TDevice } from "../../../../../common/types";
import { TNullable } from "../../../../../common/types/common";

interface Props {
    userId: string | number;
}

const Devices: FC<Props> = ({ userId }) => {
    const [selectedDevice, setSelectedDevice] = useState<TNullable<TDevice>>(null);

    const { data: devicesResponse, isLoading } = useAllDevicesForUser(userId, {
        onError: () => {
            toastError("Can't fetch machine list data");
        }
    });

    const { data } = getResponseItemData(devicesResponse);

    const deviceList = useMemo(() => data?.map((device) => (
        <div key={`device-row-${device.serialNumber}`} className="d-flex justify-content-between mb-2">
            {device.lastKnownLocation
                ? (
                    <a
                        className="fs-16 fw-bold"
                        onClick={() => { setSelectedDevice({...device}); }}
                        title="Show device on the map"
                    >{device.serialNumber}</a>
                ) : device.serialNumber
            }

            <Link
                to={machineDetailPath(device.serialNumber)}
                className="fs-16 fw-bold"
            >
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </Link>
        </div>
    )), [data]);

    const devicesWithCoords = useMemo(() => data ? data.filter(({ lastKnownLocation }) => !!lastKnownLocation) : [],[data]);

    return (
        <Container fluid className="m-0 p-0">
            <Row>
                <Col xl={9} lg={12} className="mb-3">
                    <Card className="h-100">
                        <CardHeader>
                            <CardTitle>Last Location</CardTitle>
                        </CardHeader>
                        <CardBody className="pt-0 pb-0">
                            <div style={{height: '500px'}}>
                                <MapWithMarkers
                                    devices={devicesWithCoords}
                                    selectedDevice={selectedDevice}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} lg={12} className="mb-3">
                    <Card className="h-100">
                        <CardHeader>
                            <CardTitle>My Machines</CardTitle>
                        </CardHeader>
                        <CardBody>
                            {deviceList?.length ? deviceList : "No machines yet"}
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {isLoading && (
                <>
                    <ScreenOverlay />
                    <Spinner />
                </>
            )}
        </Container>
    );
};

export default Devices;
